import * as path from "node:path";
import { checkHasProjectFile } from "@prismicio/plugin-kit/fs";
import { stripIndent } from "common-tags";
import { loadFile, builders, writeFile } from "magicast";
import { rejectIfNecessary } from "../lib/rejectIfNecessary.js";
const NUXT_PRISMIC = "@nuxtjs/prismic";
const installDependencies = async ({ installDependencies: installDependencies2 }) => {
  await installDependencies2({
    dependencies: {
      [NUXT_PRISMIC]: "^1.4.2"
    },
    dev: true
  });
};
const configurePrismicModule = async ({ helpers, project }) => {
  let nuxtConfigFilename = "nuxt.config.js";
  if (!await checkHasProjectFile({ filename: nuxtConfigFilename, helpers })) {
    nuxtConfigFilename = "nuxt.config.ts";
    if (!await checkHasProjectFile({ filename: nuxtConfigFilename, helpers })) {
      return;
    }
  }
  const nuxtConfigPath = helpers.joinPathFromRoot(nuxtConfigFilename);
  const mod = await loadFile(nuxtConfigPath);
  const endpoint = project.config.apiEndpoint || `https://${project.config.repositoryName}.cdn.prismic.io/api/v2`;
  let config;
  try {
    config = mod.exports.default.$type === "function-call" ? mod.exports.default.$args[0] : mod.exports.default;
  } catch {
    const errorMessage = `Failed to update ${path.basename(nuxtConfigPath)}`;
    console.error(errorMessage);
    console.warn(`Ensure that the following has been added to ${path.basename(nuxtConfigPath)}.`);
    console.warn(stripIndent`
			{
				buildModules: ["@nuxtjs/prismic"],
				prismic: {
					endpoint: "${endpoint}",
					modern: true
				}
			}
		`);
    throw errorMessage;
  }
  let hasInlinedConfiguration = false;
  const hasPrismicModuleRegistered = !![
    ...config.modules || [],
    ...config.buildModules || []
  ].find((registration) => {
    if (typeof registration === "string") {
      return registration === NUXT_PRISMIC;
    } else if (Array.isArray(registration)) {
      hasInlinedConfiguration = !!registration[1];
      return registration[0] === NUXT_PRISMIC;
    }
    return false;
  });
  if (!hasPrismicModuleRegistered) {
    config.buildModules ||= [];
    config.buildModules.push(NUXT_PRISMIC);
  }
  if (!hasInlinedConfiguration) {
    mod.imports.$add({
      from: "./prismic.config.json",
      imported: "apiEndpoint"
    });
    mod.imports.$add({
      from: "./prismic.config.json",
      imported: "repositoryName"
    });
    if (config.prismic) {
      config.prismic.endpoint = builders.raw("apiEndpoint || repositoryName");
    } else {
      config.prismic = {
        endpoint: builders.raw("apiEndpoint || repositoryName"),
        modern: true
      };
    }
  }
  await writeFile(mod, nuxtConfigPath);
};
const modifyPrismicConfig = async ({ helpers, options, actions }) => {
  const hasSrcDirectory = await checkHasProjectFile({
    filename: "src",
    helpers
  });
  const project = await helpers.getProject();
  if (hasSrcDirectory && project.config.libraries && JSON.stringify(project.config.libraries) === JSON.stringify(["./slices"])) {
    const sliceLibrary = await actions.readSliceLibrary({
      libraryID: project.config.libraries[0]
    });
    if (sliceLibrary.sliceIDs.length < 1) {
      project.config.libraries = ["./src/slices"];
    }
  }
  await helpers.updatePrismicConfig(project.config, {
    format: options.format
  });
};
const projectInit = async ({ installDependencies: _installDependencies }, context) => {
  rejectIfNecessary(await Promise.allSettled([
    installDependencies({ installDependencies: _installDependencies }),
    configurePrismicModule(context),
    modifyPrismicConfig(context)
  ]));
};
export {
  projectInit
};
//# sourceMappingURL=project-init.js.map
